import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../../components/dashboard-layout/layout";
import ViewDetailsComponent, {
  TopicType,
  ViewTopic,
} from "../../../components/view-details.component";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { getQuizardById } from "../apis/quizard.api";
import DeleteQuizardDialog from "../dialogs/delete-quizard.dialog";
import EditQuizardDialog from "../dialogs/edit-quizard.dialog";
import { QuizardDetailsEntity } from "../entities/quizard-details.entity";
import { QuizardDetailsModel } from "../models/quizard-details.model";

const topics: ViewTopic[] = [
  {
    title: "Cover Image",
    contentKey: "imageUrl",
    type: TopicType.image,
  },
  {
    title: "Cover Video",
    contentKey: "videoUrl",
    type: TopicType.video,
  },
  {
    title: "Title",
    contentKey: "title",
    type: TopicType.string,
  },
  {
    title: "Description",
    contentKey: "description",
    type: TopicType.string,
  },
  {
    title: "Album Tag",
    contentKey: "albumTag",
    type: TopicType.string,
  },
  {
    title: "Type",
    contentKey: "type",
    type: TopicType.string,
  },
  {
    title: "Created At",
    contentKey: "createdAt",
    type: TopicType.dateTime,
  },
  {
    title: "Last Update",
    contentKey: "updatedAt",
    type: TopicType.dateTime,
  },
];

export default function ViewQuizardPage() {
  const [searchParams] = useSearchParams();
  const [quizard, setQuizard] = useState<QuizardDetailsEntity>();
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const initEffect = useRef<boolean>(false);
  const setAlert = useDashboardStore((state) => state.setAlert);

  useEffect(() => {
    if (initEffect.current === false) {
      const id = searchParams.get("id");
      if (id) {
        getQuizardById(id)
          .then((response) => {
            const newPastPage = new QuizardDetailsModel(
              response.data
            ).toEntity();
            setQuizard(newPastPage);
          })
          .catch((error) => {
            setAlert({
              message: error.response.data.message,
              type: AlertType.error,
            });
          });
      }
    }
    return () => {
      initEffect.current = true;
    };
  }, [searchParams, setAlert]);

  return (
    <Layout>
      {quizard && (
        <EditQuizardDialog
          open={editModalOpen}
          setOpen={setEditModalOpen}
          quizard={quizard}
        />
      )}
      {quizard && (
        <DeleteQuizardDialog
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          quizard={quizard}
        />
      )}
      <div className="flex">
        <div className="flex-grow px-4 sm:px-0">
          <h3 className="text-base font-semibold leading-7 text-gray-900">
            Quizard Details
          </h3>
        </div>
        <button
          className="mx-1 rounded-md bg-indigo-600 px-3 py-1.5 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setEditModalOpen(true)}
        >
          Edit
        </button>
        <button
          className="mx-1 rounded-md bg-red-600 px-3 py-1.5 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setDeleteModalOpen(true)}
        >
          Delete
        </button>
      </div>

      {quizard && <ViewDetailsComponent topics={topics} content={quizard} />}
    </Layout>
  );
}
